var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{ref:"app",style:({ background: _vm.$vuetify.theme.themes.light.background })},[_c('router-view'),(
      _vm.UserRole &&
      (_vm.UserRole == 'TEACHER' || _vm.UserRole == 'STUDENT' || _vm.UserRole == 'ADMIN')
    )?[_c('TicketButton')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }